import { oidcEarlyInit } from 'oidc-spa/entrypoint';

const { shouldLoadApp } = oidcEarlyInit({
  freezeFetch: true,
  freezeXMLHttpRequest: true,
  freezeWebSocket: true,
});

if (shouldLoadApp) {
  import('./main.lazy');
}
